import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { SizesResponse, AllSizesResponse, SizesDropDownResponseModel, SizesDropDownDto, itemSubCatIdreq } from '@gtpl/shared-models/masters';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Raw, Repository } from 'typeorm';
import { SizesAdapter } from './dto/sizes-adapter';
import { SizesRequest } from './dto/sizes-request';
import { SizesDto } from './dto/sizes-dto';
import { Sizes } from './sizes-entity';
import { CategoryItemRequest } from './dto/category-item.request';
import { Like } from 'typeorm';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { CommonResponse } from '@gtpl/shared-models/production-management';

@Injectable()
export class SizesService {
    constructor(
      private logService:LogsService,

        @InjectRepository(Sizes) private SizesRepository: Repository<Sizes>,
        private SizesAdapter: SizesAdapter,
    ) { }


    async getSizesWithoutRelations(itemCategoryId: number, sizeName:string, itemSubCategoryId: number): Promise<Sizes> {
        const response = await this.SizesRepository.findOne({
        where: {itemCategoryId: Raw(alias => `item_category_id = '${itemCategoryId}'`), itemSubCategoryId: Raw(alias => `item_sub_category_id = '${itemSubCategoryId}'`), sizeName: Raw(alias => `REPLACE(size_name,' ','') = '${(sizeName.replace(/ /g,''))}'`) },
        });
       if (response) {
            return response;
        } else {
            return null;
        }
    }

    async createSize(sizesdto: SizesDto, isUpdate: boolean, request: Request): Promise<SizesResponse> {
        try {

            console.log(sizesdto);

            if (!isUpdate) {
                const sizesEntity = await this.getSizesWithoutRelations(sizesdto.itemCategoryId, sizesdto.sizeName, sizesdto.itemSubCategoryId);
                if (sizesEntity) {
                    throw new SizesResponse(false,11104, 'size already exists');
                }
            }else{
                const sizesEntity = await this.getSizesWithoutRelations(sizesdto.itemCategoryId, sizesdto.sizeName, sizesdto.itemSubCategoryId);
                if(sizesEntity){
                    if (sizesEntity.sizeId!=sizesdto.sizeId) {
                        throw new SizesResponse(false,11104, 'size already exists');
                    }
                }
                
            }
            const convertedsizeEntity: Sizes = this.SizesAdapter.convertDtoToEntity(sizesdto, isUpdate);
            const savedsizesEntity: Sizes = await this.SizesRepository.save(convertedsizeEntity);
            const savedsizeDto: SizesDto = this.SizesAdapter.convertEntityToDto(savedsizesEntity);

            if (savedsizeDto) {
                const response = new SizesResponse(true, isUpdate ? 11100 : 11101, isUpdate ? 'Size Updated Successfully' : 'Size Created Successfully', savedsizeDto);
                const name=isUpdate?'updated':'created'
                const newLogDto = new LogsDto(1,name, 'Sizes', savedsizeDto.sizeId, true, '','')
                let res = await this.logService.createLog(newLogDto);
                console.log(res);
                return response;
            } else {
                throw new SizesResponse(false,11106, 'size saved but issue while transforming into DTO');
            }
        }
        catch (error) {
            return error;
        }
    }


    async getAllSizes(): Promise<AllSizesResponse> {
        try {

            const sizesEntities: SizesDto[] = await this.SizesRepository.createQueryBuilder('sizes')
            .select('sizes.size_id as sizeId , sizes.size_name as sizeName, sizes.item_category_id as itemCategoryId, itemCategory.item_category as itemCategory, sizes.item_id as itemId, items.item_name as itemName,sizes.item_sub_category_id as itemSubCategoryId, itemSubCategory.item_sub_category as itemSubCategory, sizes.is_active as isActive, sizes.created_at as createdAt, sizes.created_user createdUser , sizes.updated_at as updatedAt, sizes.updated_user as updatedUser , sizes.version_flag as versionFlag')
            .leftJoin('item_categories', 'itemCategory', 'itemCategory.item_category_id = sizes.item_category_id')
            .leftJoin('items','items','items.item_id = sizes.item_id')
            .leftJoin('item_sub_categories','itemSubCategory','itemSubCategory.item_sub_category_id = sizes.item_sub_category_id')
            .orderBy('sizes.size_id')
            .getRawMany();

            if (sizesEntities.length > 0) {
                const response = new AllSizesResponse(true, 11208, "Sizes retrieved successfully", sizesEntities);
                const newLogDto = new LogsDto(1,'view', 'Sizes', 0, true, '','')
                let res = await this.logService.createLog(newLogDto);
                console.log(res);
                return response;
            } else {
                throw new SizesResponse(false,99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getAllActiveSizesDropDownForCategory(req:CategoryItemRequest): Promise<SizesDropDownResponseModel> {
        try {
            const sizesEntities: SizesDropDownDto[] = await this.SizesRepository.createQueryBuilder('sizes')
            .select('sizes.size_id as sizeId , sizes.size_name as sizeName')
            .where(`sizes.item_category_id='${req.categoryId}' and sizes.item_sub_category_id='${req.itemSubCategoryId}' and sizes.is_active=1`)
            .orderBy('sizes.size_name')
            .getRawMany();

            if (sizesEntities && sizesEntities.length > 0) {
                const response = new SizesDropDownResponseModel(true, 11108, "Sizes retrieved successfully", sizesEntities);
                return response;
            } else {
                throw new SizesResponse(false,99998, 'Data not found');
            }
        } catch (err) {
            return err;
        }
    }

    async getSize(sizeid: number): Promise<Sizes> {
        const response = await this.SizesRepository.findOne({
            where: { sizeId: sizeid },
        });
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async getSizeId(sizeName: string,itemSubCategoryId:number): Promise<Sizes> {
        const response = await this.SizesRepository.findOne({
            where: { sizeName: sizeName,itemSubCategoryId:itemSubCategoryId },
        });
        if (response) {
            return response;
        } else {
            return null;
        }
    }
    


    async activateOrDeactivateSize(sizeReq: SizesRequest): Promise<SizesResponse> {
        try {
            const sizeExists = await this.getSizeById(sizeReq.sizeId);
            if (sizeExists) {
                if (sizeReq.versionFlag !== sizeExists.versionFlag) {
                    throw new SizesResponse(false,10113, 'Someone updated the current Size information.Refresh and try again');
                } else {

                    const sizeStatus = await this.SizesRepository.update(
                        { sizeId: sizeReq.sizeId },
                        { isActive: sizeReq.isActive, updatedUser: sizeReq.updatedUser });

                    if (sizeExists.isActive) {
                        if (sizeStatus.affected) {
                            const sizeResponse: SizesResponse = new SizesResponse(true, 10115, 'Size is de-activated successfully');
                            return sizeResponse;
                        } else {
                            throw new SizesResponse(false,10111, 'Size is already deactivated');
                        }
                    } else {
                        if (sizeStatus.affected) {
                            const sizeResponse: SizesResponse = new SizesResponse(true, 10114, 'Size is activated successfully');
                            return sizeResponse;
                        } else {
                            throw new SizesResponse(false,10112, 'Size is already  activated');
                        }
                    }
                    // }
                }
            } else {
                throw new SizesResponse(false,99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getSizeById(sizeId: number): Promise<Sizes> {
        const response = await this.SizesRepository.findOne({
            where: { sizeId: sizeId },
        });

        if (response) {
            return response;
        } else {
            return null;
        }
    }

    /**
     * gets all sizes details  
     * @returns all sizes details .
     */
    async getAllActiveSizesDropDown(): Promise<SizesDropDownResponseModel> {
        try {
            const sizeDTO: SizesDropDownDto[] = [];
            const sizeEntities: Sizes[] = await this.SizesRepository.find({ select: ['sizeId', 'sizeName'], where: { isActive: true }, order: { sizeName: 'ASC' } });
            if (sizeEntities && sizeEntities.length > 0) {
                sizeEntities.forEach(sizeEntity => {
                    sizeDTO.push(new SizesDropDownDto(sizeEntity.sizeId, sizeEntity.sizeName));
                });
                const response = new SizesDropDownResponseModel(true, 11108, "Sizes retrieved successfully", sizeDTO);
                return response;
            } else {
                throw new SizesResponse(false,99998, 'Data not found');
            }
        } catch (err) {
            return err;
        }
    }

    /**
   * gets all sizes details  
   * @returns all sizes details .
   */
    async getAllSizesDropDown(): Promise<SizesDropDownResponseModel> {
        try {
            const sizeDTO: SizesDropDownDto[] = [];
            const sizeEntities: Sizes[] = await this.SizesRepository.find({ select: ['sizeId', 'sizeName','itemSubCategoryId'], order: { sizeName: 'ASC' } });
            if (sizeEntities && sizeEntities.length > 0) {
                sizeEntities.forEach(sizeEntity => {
                    sizeDTO.push(new SizesDropDownDto(sizeEntity.sizeId, sizeEntity.sizeName,sizeEntity.itemSubCategoryId));
                });
                const response = new SizesDropDownResponseModel(true, 11108, "Sizes retrieved successfully", sizeDTO);
                return response;
            } else {
                throw new SizesResponse(false,99998, 'Data not found');
            }
        } catch (err) {
            return err;
        }
    }

    async getSizeDataById(sizeReq: SizesRequest): Promise<SizesDropDownDto> {
        const ItemEntities = await this.SizesRepository.findOne({
            select: ['sizeId', 'sizeName'],
            where: { sizeId: sizeReq.sizeId }
        });
        console.log(ItemEntities);
        if (ItemEntities) {
            const response = new SizesDropDownDto(ItemEntities.sizeId, ItemEntities.sizeName);
            return response;
        } else {
            return new SizesDropDownDto(null,null);
        }

    }

    async getSizeByItemSubCategory(itemCategoryId: itemSubCatIdreq): Promise<CommonResponse> {
        let resData =[]
        const response: Sizes[]= await this.SizesRepository.find({
            where: { itemSubCategoryId: itemCategoryId.itemSubcatId },
        });
        if (response) {
            for(const res of response){
                resData.push(res)
            }
            return new CommonResponse(true,1,'Data retrived',resData)
        } else {
            return null;
        }
    }
}
